module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('strong', [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/005_Concerns#fm-1"
    }
  }, [_vm._v("Concerns about Conspiracy Theories for Christians")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/005_Concerns#fm-1"
    }
  }, [_c('em', [_vm._v("Michael W. Austin and Gregory L. Bock")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Chapter01#ch-1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Jesus as the Truth")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Chapter01#ch-1"
    }
  }, [_c('em', [_vm._v("Stephen T. Davis and Eric T. Yang")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter02#ch-2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Is It Always Wrong to Believe a Conspiracy Theory?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Chapter02#ch-2"
    }
  }, [_c('em', [_vm._v("Chad Bogosian")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter03#ch-3"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Cost of Debunking Conspiracy Theories")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Chapter03#ch-3"
    }
  }, [_c('em', [_vm._v("Scott Culpepper")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Can We Trust Science?")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/009_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Garrett J. DeWeese")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Conspiracy Theories and Meaning in Life")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/010_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Shawn Graves and Marlena Graves")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Lost Christian Virtue of Reasonableness")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/011_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("David A. Horner")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/012_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("A Failure of Humble Proportions")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Michael W. Austin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Getting Angry")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Gregory L. Bock")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    staticClass: "sp"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("It’s Much Worse Than You Think")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("J. Aaron Simmons and Kevin Carnahan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("All Christians Are Conspiracy Theorists")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Christian B. Miller")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Christianity, Conspiracy Theories, and Intellectual Character")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Nathan L. King and Keith D. Wyma")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("How Shall We Then Think? Biblical Insights on Conspiracy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Dru Johnson")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Faith, Reason, and Conspiracy Theories")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Domonique Turnipseed")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Greatest Conspiracy Ever")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Susan Peppers-Bates")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Testing Teachings and Torching Teachers")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rick Langer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Word Spoken at the Proper Time")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Tim Muehlhoff")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Following Christ into Controversy")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Jason Cook")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("The Religious Rhetoric of QAnon")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Chase Andre")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/024_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Loving Our Online Communities")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rachel I. Wightman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Conspiracy Theories, Political Trust, and Christian Witness")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Daniel Bennett")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter21#ch-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("A City Divided")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter21#ch-21",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Kaitlyn Schiess")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter22#ch-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("They Are Coming for the Children")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter22#ch-22",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Michelle Panchuk")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter23#ch-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Parenting Teenagers in Gullible Times")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter23#ch-23",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Bradley Baurain")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter24#ch-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Jesus Was Also Conspired Against, Yet He Was without Sin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-aut"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Chapter24#ch-24",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Steven L. Porter")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Appendix#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Appendix: Careful Reasoning Guide")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm1"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Contributer#bm-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("List of Contributors")])]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-064c758a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/004_Contents.vue
// module id = 66
// module chunks = 0